import { useFinanceiroObraDetailDialog } from "./use-financeiro-obra-detail-dialog";
import { FinanceiroObraDetailDialogView } from "./view-financeiro-obra-detail-dialog";
import type { FinanceiroObraDetailDialogProps } from "./types-financeiro-obra-detail-dialog";

export function FinanceiroObraDetailDialog(props: FinanceiroObraDetailDialogProps) {
  const vm = useFinanceiroObraDetailDialog(props);

  return <FinanceiroObraDetailDialogView {...vm} />;
}

export type * from "./types-financeiro-obra-detail-dialog";
